<template>
  <div class="container-fluid">
    <div class="row body-main-row">
      <div class="member_dashboard member-body-content-wrap">
        <div class="claim-wrap">
          <div class="claim-contents">
            <div class="claim-title">
              <h1>Claim Listing - {{ user.name }}</h1>
              <div>
                <button class="download-file-btn" v-b-modal.downloadFileModal>
                  <i class="fas fa-download"></i><span class="ml-2">Download the claim</span>
                </button>
                <button class="upload-file-btn" @click="openForm">
                  <i class="fas fa-upload"></i><span class="ml-2">Upload the claim</span>
                </button>
              </div>
            </div>
            <file-download-modal />

            <div class="claim-list-tbl table-responsive">
              <p class="text-center" style="font-size: 20px;" v-if="claimList.length < 1">
                No data found
              </p>
              <table v-else class="table w-100">
                <thead>
                  <tr>
                    <th>Plan</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Email Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(claim, index) in claimList" :key="index">
                    <td style="width: 57%;">{{ claim.plan_name }}</td>
                    <td :class="claim?.status?.toLowerCase()">
                      {{ claim?.status?.toUpperCase() }}
                    </td>
                    <td>
                      <strong>Added: </strong> {{ formatDate(claim.created_at)
                      }}<br />
                      <span v-if="claim.submitted_at">
                        <strong>Submitted: </strong>
                        {{ formatDate(claim.submitted_at) }}</span>
                    </td>
                    <td class="text-center">
  <b-badge pill :style="{
      backgroundColor: statusClass(claim?.email_delivery_status),
    }">
    {{ claim?.email_delivery_status || 'Not Available' }}
  </b-badge>
</td>


                    <!-- <td>{{ claim?.email_delivery_status }}</td> -->
                    <td class="d-flex align-items-center">
                      <div class="mr-3 action-bg" v-b-tooltip.hover :title="claim.status.toLowerCase() === 'submitted'
                  ? 'View File'
                  : 'Edit/View File'
                  " @click="viewFile(claim)">
                        <i class="fas fa-eye"></i>
                      </div>
                      <div v-if="claim.status.toLowerCase() === 'pending'" class="action-bg submit-file"
                        v-b-tooltip.hover title="Submit file" @click="openSubmitModal(claim)">
                        <img src="../../assets/file-circle.svg" alt="submit" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <file-submit-modal v-if="selectedFiles" :files="selectedFiles" :claimData="claimData"
                @close="selectedFiles = null" />
              <file-upload-modal :isEdit="isEdit" :row="selectedClaim" @close="selectedClaim = null"
                @update-isEdit="isEdit = $event" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Api from "@/resource/MemberApi";
import axios from "axios";

import FileUploadModal from "./FileUploadModal.vue";
import FileDownloadModal from "./FileDownloadModal.vue";
import FileSubmitModal from "./FileSubmitModal.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    FileUploadModal,
    FileDownloadModal,
    FileSubmitModal,
  },
  data() {
    return {
      details: [],
      files: [],
      claimList: [],
      claimData: [],
      selectedClaim: null,
      selectedFiles: null,
      isEdit: false,
    };
  },
  methods: {
    viewFile(claim) {
      this.isEdit = true;
      this.selectedClaim = claim;
      this.$bvModal.show("uploadFileModal");
    },
    statusClass(status) {
      switch (status?.toLowerCase()) {
        case "sent":
          return "#003964";
        case "queued":
          return "orange";
        case "blacklisted":
          return "#000";
        case "invalid":
          return "red";
        case "delivered":
          return "#05ac05";
        case "opened":
          return "#037003";
        case "bounced":
          return "#ed1c24";
        case "blocked":
          return "#003964";
        case "unsubscribed":
          return "#ff2400";
        default:
          return "";
      }
    },
    formatDate(date) {
      if (date) {
        const formattedDate = new Date(date);
        return formattedDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      }
      return "";
    },
    openForm() {
      this.selectedClaim = {};
      this.$bvModal.show("uploadFileModal");
    },
    openSubmitModal(claim) {
      this.claimData = claim;
      this.selectedFiles = claim.files;
      this.$bvModal.show("submitFile");
    },
    getClaimList() {
      let loader = this.$loading.show();
      let url = "prudential-claim/list";
      axios
        .get(url)
        .then((res) => {
          if (res.data.status === "success") {
            this.claimList = res.data.data;

            this.claimList.forEach((claim) => {
              claim.status = claim.status == 1 ? "submitted" : "pending";
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  created() {
    this.getClaimList();
  },
   computed: {
    ...mapGetters({ user: "user" }),
  },
};
</script>
<style>
@import "../../assets/css/claim-list.css";

input[type="file"] {
  display: none;
}

.choose-file-btn {
  display: inline-block;
  padding: 24px 24px;
  margin: 5px 0;
  background-color: #f1f0ef;
  color: rgb(39, 39, 39);
  border: none;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
}

.choose-file-btn:focus {
  outline: none;
}

.action-bg {
  cursor: pointer;
}

/* .choose-file-btn:hover {
  background-color: #0099ff;
} */
</style>
